import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class FontFamily extends BaseOption {
  static myOptions = [
    { id: "standard", name: "Standard" },
    { id: "fancy", name: "Fancy" },
    { id: "heading", name: "Heading" },
    { id: "accent", name: "Accent" },
  ];

  static userInterfaceComponent = {
    label: "Font Family",
    component: inspectorTools.FONT_FAMILY_PICKER_V2,
  };

  get myOptions() {
    return this.constructor.myOptions;
  }

  static defaultValue = "standard";

  static convertConfigValueToCompiledValue(configValue, themeId) {
    if (this.myOptions.find(value => value.id === configValue)) {
      return BaseOption.getFontValue(configValue, themeId);
    }
    if (typeof configValue === "string") {
      return configValue;
    }
    // Re-resolve theme picks from the alias so remaps stay live, not pinned to `.value`.
    if (configValue?.context === "theme") {
      const aliasId = (configValue.label ?? "").replaceAll(" ", "").toLowerCase();
      if (this.myOptions.find(value => value.id === aliasId)) {
        return BaseOption.getFontValue(aliasId, themeId);
      }
    }
    return configValue.value;
  }
}
